import COMPLEXITY from '../../constants/complexity';
import DAY_OR_NIGHT from '../../constants/day_or_night';
import CATEGORIES from '../../constants/categories';

const DEFAULT_SELECTED_CATEGORIES = {
  [COMPLEXITY.SIMPLE]: {
    [DAY_OR_NIGHT.DAY]: [
      CATEGORIES.SERUM, CATEGORIES.MOISTURIZER, CATEGORIES.SPF,
    ],
    [DAY_OR_NIGHT.NIGHT]: [
      CATEGORIES.SERUM, CATEGORIES.EYE_TREATMENT, CATEGORIES.MOISTURIZER,
    ],
  },
  [COMPLEXITY.COMPLEX]: {
    [DAY_OR_NIGHT.DAY]: [
      CATEGORIES.CLEANSER, CATEGORIES.EXFOLIATOR, CATEGORIES.SERUM,
      CATEGORIES.EYE_TREATMENT, CATEGORIES.MOISTURIZER, CATEGORIES.SPF, CATEGORIES.MIST,
    ],
    [DAY_OR_NIGHT.NIGHT]: [
      CATEGORIES.CLEANSER, CATEGORIES.EXFOLIATOR, CATEGORIES.MASK,
      CATEGORIES.SERUM, CATEGORIES.EYE_TREATMENT, CATEGORIES.MOISTURIZER, CATEGORIES.BODY,
    ],
  },
};

const defaultSelectedCategories = (complexity, dayOrNight) => {
  const selectedDayOrNight = dayOrNight === DAY_OR_NIGHT.NIGHT
    ? DAY_OR_NIGHT.NIGHT
    : DAY_OR_NIGHT.DAY;
  const categoriesByComplexity = DEFAULT_SELECTED_CATEGORIES[complexity]
    || DEFAULT_SELECTED_CATEGORIES[COMPLEXITY.COMPLEX];

  return [...(categoriesByComplexity[selectedDayOrNight] || [])];
};

export default defaultSelectedCategories;
